<template>
    <div class="register">
        <Form/>
    </div>
</template>
<script>
import Form from '@/components/Form'
export default {
    name:'Register',
    components:{
        Form
    }
    
}
</script>
<style scoped lang="scss">
.register{
    height:100%;
}    
</style>